<template>
    <div class="pa-0" v-if="liftmanager">
        <d-inbox-detail
            v-model     = "details.show"
            :attachment = "details.message"
            :height     = "fullheight"
            @morph      = "onMorph"
            @context    = "onContext"
        />

        <c-drawer-header
            v-resize   = "onResize"
            title      = "Inbox"
            :subtitle  = "customer ? customer.name : null"
            icon       = "fas fa-inbox"
            :usefilter = "true"
            :usetoggle = true
            @close     = "onClose"
            @filter    = "onFilter"
            @toggle    = "onToggle"
            @arrow     = "onArrow"
        >
            <template v-slot:toolbar>
                <div class="v-flex pr-1" style="margin-top: -2px">
                    <c-toolbar-button
                        icon="mdi-reload"
                        tooltip="Meldungen erneut laden"
                        color="white"
                        size="20"
                        @click ="onReload"
                    />
                </div>
            </template>
        </c-drawer-header>
        <v-expand-transition>
            <div v-if="filter" class="filter-panel">
                <v-row dense>
                    <v-col class="pr-2">
                        <div>
                            <c-customer-select
                                v-model       = "customer"
                                label         = "Kunde"
                                :my-customers = "true"
                                :hide-details = "true"
                            />
                        </div>
                    </v-col>
                    <v-col class="pl-2">
                        <f-enum-select
                            v-model   = "messagetype"
                            label     = "Meldungsart"
                            module    = "inb"
                            type      = "messageTypes"
                            clearable
                            hide-details
                        />
                    </v-col>
                </v-row>

                <div class="mt-3 mb-3">
                    <v-text-field
                        v-model        = "searchtext"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        label          = "Volltextsuche"
                        clearable
                        hide-details
                    />
                </div>
            </div>
        </v-expand-transition>

        <div v-if="loading">
            <v-progress-linear
                color  = "primary"
                height = "4"
                indeterminate
            />
        </div>

        <v-row dense>
            <v-col class="inb-messages-col">
                <v-layout row wrap  class="inb-messages-list" :style="'height: ' + height + 'px'">
                    <drop
                        class="cut"
                        @drop        = "onDrop"
                        :accepts-type="onAcceptType"
                        mode         = "cut"
                    >
                        <div v-if="messages.length === 0" class="inb-no-messages">
                            Keine Meldungen vorhanden
                        </div>
                        <v-container v-if="messages.length > 0" fluid class="w-100 pa-0">
                        <v-data-iterator
                            :items         = "messages"
                            :search        = "searchtext"
                            :custom-filter = "cfilter"
                            hide-default-footer
                            :items-per-page="100"
                            :key = "refresh"
                        >
                            <template v-slot:default="props">
                                <drag
                                    v-for="(item,index) in props.items"
                                    class      = "item"
                                    @cut       = "onRemove(item)"
                                    @dragend   = "onDragend"
                                    :key       = "item.id"
                                    :type      =  "dragData (item)"
                                    :disabled  = "item.incidentId!==null"
                                    :data      = "dragData(item)"
                                >
                                    <inb-message-entry
                                        :message = "item"
                                        :context = "context"
                                        v-model  = "menuOpen"
                                        @edit    = "onEdit"
                                        :class   = "index < props.items.length-1 ? 'mb-4' : ''"
                                    />
                                </drag>
                            </template>
                        </v-data-iterator>
                    </v-container>
                    </drop>
                </v-layout>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import Inb             from "@/modules/inb/service/Inb.js";
import InbMessageEntry from "@/modules/inb/components/nav/InbMessageEntry";
import { Drag, Drop }  from "vue-easy-dnd"
import CDrawerHeader   from "@/modules/core/components/utils/CDrawerHeader";
import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import DInboxDetail from "@/modules/inb/components/main/details/DInboxDetail";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "InboxMessageDrawer",

    props: {
        open: {
        }
    },

    components: {
        CToolbarButton,
        DInboxDetail,
        FEnumSelect,
        CCustomerSelect,
        CDrawerHeader,
        InbMessageEntry,
        Drag,
        Drop
    },

    data: () => ({
        details: {
            show: false,
            message: null,
        },
        menuOpen   : false,
        height     : null,
        fullheight : null,
        filter     : false,
        customer   : null,
        searchtext : null,
        usecontext : false,
        messagetype: null,
        right      : true,
        refresh    : 0,
        loading    : false,
        context    : {
            incident: null,
            site    : null
        }
    }),

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        myCustomers () {
            return this.preferences.customer;
        },

        liftmanager() {
            return Core.role.liftmanager();
        },

        unit () {
            const site = this.$store.getters.site;
            if (!site) {
                return null;
            }

            return site;
        },

        messages() {
            let result = this.$store.getters.messages;

            if (this.customer != null) {
                result = result.filter(message => (message.customer ? message.customer.id : null) === this.customer.id);
            }

            if (this.messagetype) {
                result = result.filter(message => (message.type ? message.type.id : null) === this.messagetype.id);
            }

            const context = this.$store.getters.context;
            if (this.usecontext && context.site) {
                result = result.filter(message => {
                    return message.sites.filter (site => site.id === parseInt (context.site)).length > 0;
                });
            }

            if (this.usecontext && this.context.incident) {
                result = result.filter(message => {
                    let found = false;
                    message.sites.forEach(site => {
                        if (context.incident.sites.filter (s => s.id === site.id).length > 0) {
                            found = true;
                        }
                    })

                    return found;
                });
            }

            return result;
        },
    },

    watch: {
        unit () {
            this.initialize ();
        },
        customer () {
            this.refresh ++;
        },
        open () {
            if (this.open) {
                this.load(true);
            }
        }
    },

    methods: {
        initialize () {
            if (!this.unit) {
                return;
            }

            this.customer = this.unit.customer;
        },

        onInsert () {

        },

        onFilter () {
            this.filter = !this.filter;
            this.onResize ();
        },

        onToggle () {
            this.usecontext = !this.usecontext;
        },

        onArrow (value) {
            this.$emit("position", value);
        },

        onAcceptType (message) {
            if (!(message instanceof Object)) {
                return;
            }

            if (message.type === "dms-document") {
                return message.data.messageId && !message.data.stamped;
            }

            return false;
        },

        onDrop (message) {
            Inb.detach(this, message.data.data.messageId);
        },

        onRemove () {
            this.$bus.$emit(Inb.event.refresh);
            this.$emit("close");
        },

        onDragend (event) {
            this.$bus.$emit(this.$events.drag.end, event);
        },

        onResize () {
            this.fullheight = window.innerHeight;
            this.height = window.innerHeight - 70;
            if (this.filter) {
                this.height = this.height - 140;
            }
        },

        onClose () {
            this.$emit("close");
        },

        onEdit (message) {
            this.details.message = message;
            this.details.show = true;
        },

        onMorph (event) {
            Inb.morph(this, event.message, event.targetId).then((attachment) => {
                this.$bus.$emit(Inb.event.attachment, attachment);
                this.details.message = attachment;
            });
        },

        onContext () {

        },

        onReload () {
            this.forceLoad();
        },

        forceLoad () {
            this.load(true);
        },

        load(force) {
            let customers = [];
            if (this.myCustomers && this.myCustomers.length > 0) {
               customers = this.myCustomers.map(c => c.id);
            }

            this.loading = true;
            this.$store.dispatch('getMessagesByUser', { customers: customers, force: force} ).then(() => {
                this.loading = false;
            });
        },

        setContext (context) {
            if (context.incident) {
                this.context = {
                    incident: context.incident,
                    site    : null
                }
                return;
            }

            if (context.site) {
                this.context = {
                    incident: null,
                    site    : context.site
                };

                return;
            }

            this.context = {
                incident: null,
                site    : null
            }
        },

        cfilter (items, search) {

            return items.filter (entry => {
                if (!search) {
                    return true;
                }

                if (entry.sites.filter(site => this.includes (site.fabricNo, search) || this.includes (site.location, search)).length > 0) {
                    return true;
                }

                if (this.includes(entry.subject, search)) {
                    return true;
                }

                if (entry.type && this.includes(entry.type.name, search)) {
                    return true;
                }

                if (entry.type.id === Inb.type.assessment) {
                    return this.includes(entry.assessmenttype, search);
                }

                if (entry.type.id === Inb.type.invoice) {
                    return entry.invoiceType && this.includes(entry.invoiceType.name, search);
                }

                return false;
            });
        },

        dragData (item) {
            return {
                type: "inbox",
                data: item
            };
        },

        includes (text, search) {
            if (!text) {
                return false;
            }

            return text.toUpperCase().includes(search.toUpperCase())
        }
    }
}

</script>

<style scoped>

.inb-messages-list {
    width: calc(100% - 10px);
    min-height: 140px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: white;
    padding: 0 0 0 10px;
    margin-top: 10px;
}

div::-webkit-scrollbar {
    width: 5px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3)!important;
    border-radius: 10px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
}

.crm-reminder-info p {
    font-size: 9pt;
    font-weight: normal;
    margin-bottom: 0;
}

.inb-messages-col {
    min-width: 100%;
    max-width: calc(100% - 55px);
    padding: 0;
}

.inb-no-messages {
    text-align: center;
    padding-top: 20px;
    height: 65px;
    font-size: 18px;
}

.filter-panel {
    margin-left: 15px;
    margin-right: 20px;
    margin-top: 15px;
    padding: 10px 15px;
    border-style: solid;
    border-width: 1px;
    border-color: #0a68b8;
    border-radius: 5px;
}
</style>
